import React from 'react';
import styled from 'styled-components';
import { legacyType } from '../../../styles/typography';

import { FormattedMessage } from 'react-intl';

const ReadMore = styled.div`
  text-transform: uppercase;
  text-decoration: underline;
  font-size: var(--fs-focus);
  font-weight: 500;
  padding: 1rem 0;
  ${legacyType('focus', 'label', { uppercase: true })};

  > div {
    display: inline-flex;
  }
`;

export default () => {
  return (
    <ReadMore>
      <FormattedMessage defaultMessage="Read more" id="grid.read-more" />
    </ReadMore>
  );
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/utils/ReadMore.js